<template>
  <q-card class="q-pa-none no-border no-box-shadow card-width">
    <q-spinner-dots color="primary" size="4em" class="q-my-md q-mx-auto block" v-if="!productData" />
    <q-slide-transition>
    <q-card-section v-if="productData" class="q-pa-none">
      <div class="row">
        <div class="col-lg-10 col-xs-8">
          <div class="col-12 q-mb-md">
            <div class="card-title">{{ productData.Name }}</div>
            <div class="card-subtitle">{{ productData.ShortDescription }}</div>
          </div>
        </div>
        <div class="col-lg-2 col-xs-4 text-right"><q-btn @click="emit('close')" flat class="btn-close q-pr-none" icon-right="close" label="CLOSE" /></div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-xs-12 q-pr-lg gallery-wrapper">
          <div class="gallery "><img :src="productData.DefaultPictureModel.FullSizeImageUrl" alt="" /></div>
        </div>
        <div class="col-lg-6 col-xs-12">
          <div class="row attributes q-py-sm">
            <div class="col-6 attributes-label text-left">STOCK LEVEL :</div>
            <div class="col-6 attributes-value text-right">
              <stock-message :showQuantity='showQuantity' :message="message" :quantity="quantity" :status="status" />
            </div>
          </div>
          <div class="attributes q-py-sm">
            <div class="attributes-label text-left">SKU :</div>
            <div class="attributes-value text-right">{{ productData.Sku }}</div>
          </div>
          <div class="attributes q-py-sm" v-for="attribute in productAttributionList.slice(0, 6)" :key="attribute.label+attribute.value">
            <div class="attributes-label text-left">{{ attribute.label }} :</div>
            <div class="attributes-value text-right"><span v-html="attribute.value"></span></div>
          </div>
          <div class="view-full-description">
            <a :href="productData.SeName">VIEW FULL DESCRIPTION AND SPECIFICATIONS</a>
          </div>
          <div class="add-to-cart-card">
            <div class="row">
              <div class="col-6">
                <span class="add-to-cart-card--price">{{ productData.ProductPrice.Price }}</span>
                <br />
                <span class="add-to-cart-card--unitprice">Unit Price: {{ productData.ProductPrice.Price }}</span>
              </div>
              <div class="col-6">
                <div class="add-to-cart-card--counter">
                  <q-icon @click="itemCount--" class="icon cursor-pointer" name="remove" />
                  <input type="text" v-model="itemCount" class="text-center input-number" />
                  <q-icon @click="itemCount++" class="icon cursor-pointer" name="add" />
                </div>
                <div class="quantity-label">Quantity</div>
              </div>
              <div class="col-12 q-pt-lg"><q-btn @click="onAddToCart" class="btn-add-to-cart" label="ADD TO CART" /></div>
            </div>
          </div>
        </div>
      </div>
    </q-card-section>
  </q-slide-transition>
  </q-card>
</template>
<script setup>
import { defineProps, defineEmits, ref, onMounted, computed } from 'vue';
import { useProductStore } from '../../stores/product-store';
import { useCartStore } from '../../stores/cart-store';
import StockMessage from './StockMessage.vue';
const { addToCart } = useCartStore();
const { getProductsDetailsById } = useProductStore();

const props = defineProps({
  // rowData: Object,
  productId: [Number, String],
  showQuantity: Boolean,
  quantity: Number,
  status: String,
  message: String,
});

const emit = defineEmits(['close']);

const itemCount = ref(1);

// const handleCount = () =>{
//   if (itemCount.value > 1) {
//     itemCount.value--
//   }
// }

const productData = ref(null);
const productAttributionList = computed(() => {
  if (!productData.value) {
    return [];
  } else {
    if (productData.value?.ProductAttributionList?.length > 0) {
      return productData.value.ProductAttributionList.map((i) => {
        return { label: i.Text, value: i.Value };
      });
    } else {
      if (productData.value?.ProductSpecifications?.length > 0) {
        return productData.value.ProductSpecifications.map((i) => {
          return { label: i.SpecificationAttributeName, value: i.ValueRaw };
        });
      } else {
        return [];
      }
    }
  }
});

onMounted(async () => {
  productData.value = await getProductsDetailsById(props.productId);
  let currentitem = document.querySelectorAll('.mini-shopping-cart .item').length;
  if (currentitem != 0) {
    document.getElementById('fixed-cart-box').style.display = 'block';
  }
});

// async function getProductData() {

// }

async function onAddToCart() {
  // productData.id
  try {
    await addToCart(productData.value.Id, itemCount.value);
    // window.displayBarNotification('The product has been added to your <a href="/cart">shopping cart</a>', 'success', 3500);
    // // flyout-cart
    // document.getElementById('flyout-cart').innerHTML = cartItems.updateflyoutcartsectionhtml;

    // document.querySelectorAll('span#myitemcount')[0].innerHTML = cartItems.updatesidecartsectionhtml;
    // document.querySelectorAll('span.cart-qty')[0].innerHTML = cartItems.updatesidecartsectionhtml;

    // document.getElementsByClassName('ajax-loading-block-window')[0].style.display = 'none';
    // // $('span.cart-qty').html(data.updatesidecartsectionhtml);
    // // $('.ajax-loading-block-window').hide();
    // try {
    //   let currentitem = document.querySelectorAll('.mini-shopping-cart .item').length;
    //   console.log(currentitem, 'currentitem');
    //   if (currentitem != 0) {
    //     // console.log(123132);

    //     document.getElementById('fixed-cart-box').style.display = 'block';
    //     // console.log(document.getElementById('fixed-cart-box'));
    //     //  $('div#myitemcount').html("(" + currentitem + ")");
    //     // let currentitemprice = document.querySelectorAll('.mini-shopping-cart .totals strong')[0].innerHTML;
    //     // document.querySelectorAll('div#mypaymenttotal')[0].innerHTML = currentitemprice;
    //     //    $('span.cart-qty').html("(" + currentitem + ")")
    //     console.log('success');
    //   } else {
    //     console.log('success else');
    //     // $('div#fixed-cart-box').hide();
    //     document.getElementById('fixed-cart-box').style.display = 'none';
    //   }
    // } catch (err) {
    //   console.log(456, err);
    //   // let v = err.message;
    //   document.getElementById('fixed-cart-box').style.display = 'none';
    //   // $('div#fixed-cart-box').hide();
    // }
  } catch (error) {
    console.log(error);
  }

  // console.log(cartItems);
}
</script>

<style scoped lang="scss">
// .card-width {
//   @media (min-width: 600px){
//     max-width: 50vw !important;
//     }
// }
.gallery-wrapper {
  @media (max-width: $breakpoint-xs) {
    padding-right: 0 !important;
  }
}
.card-title {
  font-size: 45px;
  font-weight: 600;
  text-transform: uppercase;
  color: #242625;
  line-height: 53px;
  word-break: break-all;
  width: inherit;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: break-spaces;
}

.card-subtitle {
  font-size: 30px;
  font-weight: 400;
  display: inline-block;
  text-transform: uppercase;
  color: #2682c5;
  padding-bottom: 10px;
}
.btn-close {
  color: #5680bf;
  @media (max-width: $breakpoint-xs) {
    padding: 0;
  }
}
.gallery {
  width: 100% !important;
  border: 1px solid #e5e5e5;

  img {
    margin: 0 auto;
    display: block;
    @media (max-width: $breakpoint-xs) {
      width: 100%;
    }
  }
}
.attributes {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e5e5e5;
  &-label {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.380084px;
    text-transform: uppercase;
    color: #242625;
  }
  &-value {
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.380084px;
  }
}
.stock-available {
  color: #00aa2d;
  font-weight: bold;
}

.stock-inproduction {
  color: #c42424;
  font-weight: bold;
}

.view-full-description {
  text-align: left;
  margin-top: 20px;
  text-decoration: underline;
  font-weight: normal;
  margin: 20px 0;
  a {
    color: #2681c4 !important;
  }
}

.add-to-cart-card {
  background: rgba(5, 133, 200, 0.1);
  border: 2px solid #5284c3;
  padding: 40px 20px 20px 20px;
  border-radius: 8px;

  &--price {
    font-size: 22px;
    font-weight: 700;
  }

  &--counter {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .icon {
      font-size: 30px !important;
      height: 43px !important;
      line-height: 43px !important;
      color: #2581c4 !important;
      vertical-align: middle !important;
      background: transparent !important;
      border: 0 !important;
      cursor: pointer !important;
    }
  }
  .quantity-label {
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 4px;
    display: block;
    color: #2681c4;
    font-size: 10px;
    margin-top: 5px;
    text-align: right;
    padding-right: 40px;
  }
}
.btn-add-to-cart {
  background: #5680bf !important;
  color: #fff !important;
  width: 100% !important;
}
.input-number {
  width: 70px;
  background-color: #fff;
  border: 1px solid #e5e5e5;
  height: 40px;
  font-weight: 400;
  font-size: 16px;
}
.input-number:focus {
  border: 2px solid #e5e5e5;
  outline: none;
}
.q-field__control {
  height: 40px !important;
}
</style>
